<template>
  <div>
    <section>
      <div class="inner inner--full row5">
        <div class="title alignC">
          <h1>장비 데이터</h1>
        </div>

        <section>
          <div class="mt-10">
            <div class="surveyContainer">
              <div class="surveyContainer__left">
                <div
                    class="flex groupBtnRegisterSurvey"
                >
                  <div class="serviceTabMenu equipStyle mt-4">
                    <ul>
                      <li
                          @click="activeRightTab = 1"
                          class="serviceTabMenuItem"
                          :class="{ active: activeRightTab == 1 }"
                      >
                        인바디
                      </li>
                      <li
                          @click="activeRightTab = 2"
                          class="serviceTabMenuItem"
                          :class="{ active: activeRightTab == 2 }"
                      >
                        안단테 핏
                      </li>
                    </ul>
                  </div>
                  <!-- v-if="user.roleName == this.$role.ADMIN" -->
                </div>
              </div>
              <template v-if="user.roleName == this.$role.ADMIN && activeRightTab == 1">
                <div class="surveyContainer__right flex justify-between">
                  <div class="alignL">
                    <AdminInBodyMultiselect
                        v-model="selectedInBodyOptions"
                        :externalOptions="InBodyOptions"/>
                  </div>
                  <div class="alignR">
                    <a
                        href="#"
                        class="btn-main btn-primary"
                        @click.prevent="downloadInBodyData"
                        style="background-color: #9E1915; margin-left: 10px;"
                    ><i class="ic ic--excel"></i> 데이터 다운로드</a
                    >
                    <a
                        href="javascript:void(0)"
                        class="btn-main btn-primary"
                        @click="inbodyDataRegist = true" style="background-color: #9E1915; margin-left: 10px;"
                    ><i class="ic ic--union"></i> 인바디 데이터 등록</a
                    >
                  </div>
                </div>
              </template>

              <template v-if="user.roleName == this.$role.ADMIN && activeRightTab == 2">
                <div class="surveyContainer__right">
                  <div class="alignR">
                    <a
                        href="#"
                        class="btn-main btn-primary"
                        @click.prevent="downloadEquipmentData"
                        style="background-color: #9E1915; margin-left: 10px;"
                    ><i class="ic ic--excel"></i> 데이터 다운로드</a
                    >
                    <a
                        href="javascript:void(0)"
                        class="btn-main btn-primary"
                        @click="isShowModal = true" style="background-color: #9E1915; margin-left: 10px;"
                    ><i class="ic ic--union"></i> QR 코드 데이터 등록</a
                    >
                    <a
                        href="javascript:void(0)"
                        class="btn-main btn-primary" style="background-color: #9E1915; margin-left: 10px;"
                        @click="showequipmentDataDelete = true"
                    > 삭제</a
                    >
                  </div>
                </div>
              </template>
            </div>

            <div class="surveyContainer surveyContainer--fix mt-2"
                 v-if="user.roleName == this.$role.ADMIN && activeRightTab == 1">
              <div class="surveyContainer__left">
                <div class="flex searchCommonBox">
                  <input
                      type="text"
                      class="searchInput"
                      v-model="searchText"
                      @keyup.enter="onClickSearchForInBody"
                      placeholder="검색할 내용을 입력하세요."
                  />
                  <input
                      type="button"
                      value="검색"
                      class="searchBtn searchBtnCmmn"
                      @click="onClickSearchForInBody"
                  />
                  <template v-if="user.roleName == this.$role.ADMIN">
                    <input
                        type="button"
                        value="등록"
                        class="searchBtn searchBtnCmmn"
                        @click="registInbodyRegistName = true , dataType = 'inbody'"
                    />
                    <input
                        type="button"
                        value="삭제"
                        class="searchBtn searchBtnCmmn"
                        @click="showAlertDelete = true , dataType = 'inbody'"
                    />
                  </template>
                </div>
                <div class="boxResult">
                  <div
                      class="boxResult__item"
                      v-for="(item, index) in items"
                      v-bind:class="{ active: item.IDX == itemsActive.IDX }"
                      :key="index"
                      @click="handleSelectItem(item)"
                  >
                    {{ item.TITLE }}
                  </div>

                </div>
              </div>

              <div class="surveyContainer__right table-overflow-scroll">
                <AdminInBodyTable
                    :key="inBodyTableKey"
                    :headers="InBodyFields"
                    :rowData="tableItems"
                    :selectedHeaders="selectedInBodyOptions"/>
              </div>
            </div>


            <div class="surveyContainer surveyContainer--fix mt-2"
                 v-if="user.roleName == this.$role.ADMIN && activeRightTab == 2">
              <div class="surveyContainer__left">
                <div class="flex searchCommonBox">
                  <input
                      type="text"
                      class="searchInput"
                      v-model="searchText"
                      @keyup.enter="onClickSearch"
                      placeholder="검색할 내용을 입력하세요."
                  />
                  <input
                      type="button"
                      value="검색"
                      class="searchBtn searchBtnCmmn"
                      @click="onClickSearch"
                  />
                  <template v-if="user.roleName == this.$role.ADMIN">
                    <input
                        type="button"
                        value="등록"
                        class="searchBtn searchBtnCmmn"
                        @click="registResearchName = true , dataType = 'research'"
                    />
                    <input
                        type="button"
                        value="삭제"
                        class="searchBtn searchBtnCmmn"
                        @click="showAlertDelete = true , dataType = 'research'"
                    />
                  </template>
                </div>
                <div class="boxResult">
                  <div
                      class="boxResult__item"
                      v-for="(item, index) in items"
                      v-bind:class="{ active: item.studyIdx == itemsActive.studyIdx }"
                      :key="index"
                      @click="handleSelectItem(item)"
                  >
                    {{ item.title }}
                  </div>

                </div>
              </div>
              <div class="surveyContainer__right">
                <template>
                  <div class="bootstrapTableContainer">
                    <b-table
                        ref="table"
                        :fields="fields"
                        :items="tableItems"
                        :per-page="perPage"
                        :current-page="currentPage"
                        hover
                        show-empty
                        empty-text="데이터가 존재하지 않습니다.">

                      <template #emptyfiltered="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                      </template>

                      <template #cell(selected)="data">
                        <b-form-checkbox
                            v-model="data.item.selected"
                            name="selected"
                            value="true"
                        >{{ data.IDX }}
                        </b-form-checkbox>
                      </template>

                      <template #cell(INDEX)="data">
                        {{ data.index + 1 }}
                      </template>

                      <template #cell(SHOW_DETAIL)="row">
                        <b-button size="sm" @click="onClickShowDetail(row)" class="mr-2">
                          상세보기
                        </b-button>
                      </template>

                    </b-table>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalCnt"
                        :per-page="perPage"
                        aria-controls="table">
                    </b-pagination>

                  </div>
                </template>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!--안단테핏 연구명 등록 모달 -->
      <BasicModal
          disabledFooter
          :isShowModal="registResearchName"
          size="lg"
          title="안단테핏 연구명 등록"
          @close-modal="handleCLose"
      >
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="" @submit.prevent="handleSubmit(() => handleSubmitClick())">
            <ValidationProvider
                name="연구 제목"
                rules="required"
                v-slot="{ errors }"
            >
              <InputField
                  label="연구 제목"
                  v-model="params.title"
                  :errors="errors"
              />
            </ValidationProvider>

            <div style="height: 50px"></div>
            <div class="flex flexAlignC">
              <MainButton btnText="등록" type="submit" width="auto"/>
            </div>
          </form>
        </ValidationObserver>
      </BasicModal>
      <!--인바디 연구명 등록 모달 -->
      <BasicModal
          disabledFooter
          :isShowModal="registInbodyRegistName"
          size="lg"
          title="인바디 연구명 등록"
          @close-modal="handleCLose"
      >
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="" @submit.prevent="handleSubmit(() => handleInBodySubmitClick())">
            <ValidationProvider
                name="인바디 연구 제목"
                rules="required"
                v-slot="{ errors }"
            >
              <InputField
                  label="인바디 연구 제목"
                  v-model="inBodyInfoParams.title"
                  :errors="errors"
              />
            </ValidationProvider>

            <div style="height: 50px"></div>
            <div class="flex flexAlignC">
              <MainButton btnText="등록" type="submit" width="auto"/>
            </div>
          </form>
        </ValidationObserver>
      </BasicModal>
      <!--안단테핏 QR 코드 데이터 등록 모달 -->
      <BasicModal
          disabledFooter
          :isShowModal="isShowModal"
          size="lg"
          title="안단테핏 QR 코드 데이터 등록"
          @close-modal="handleCLose"
      >
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="" @submit.prevent="handleSubmit(() => handleSubmitClick())">
            <!-- <ValidationProvider
              name="데이터 제목"
              rules="required"
              v-slot="{ errors }"
            >
              <InputField
                label="데이터 제목"
                v-model="params.title"
                :errors="errors"
              />
            </ValidationProvider> -->

            <ValidationProvider
                rules="required"
                ref="provider1"
                v-slot="{ validate, errors }"
            >
              <InputFieldFiles
                  label="데이터 업로드"
                  btnText="파일 업로드"
                  accept=".xlsx, .xls, .csv, .png, .svg, .jpg, .jpeg"
                  multiple
                  :value="params.files ? params.files.map(file => file.name).join(', ') : ''"
                  :errors="errors"
                  :change="handleFilesChange"
              />

              <div v-if="params.files && params.files.length" class="dataWrap"
                   style="height: 130px; overflow-y:auto; border: 1px solid slategray">
                <ul v-if="params.files && params.files.length" style="margin: 0px 15px 0px 0px;">
                  <li v-for="(file, index) in params.files" :key="index"
                      style="padding:5px 10px; font-size: 1.4rem; display: flex; justify-content: space-between; align-items: center;">
      <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
        {{ file.name }}
      </span>
                    <button class="btn-delete" type="button" @click="removeFile(index)">삭제</button>
                  </li>
                </ul>
              </div>
            </ValidationProvider>

            <div style="height: 50px"></div>
            <div class="flex flexAlignC">
              <MainButton btnText="등록" type="submit" width="auto"/>
            </div>
          </form>
        </ValidationObserver>
      </BasicModal>
      <!--인바디 데이터 등록 모달 -->
      <BasicModal
          disabledFooter
          :isShowModal="inbodyDataRegist"
          size="lg"
          title="인바디 데이터 등록"
          @close-modal="handleCLose"
      >
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="" @submit.prevent="handleSubmit(() => handleInBodySubmitClick())">
            <!-- <ValidationProvider
              name="데이터 제목"
              rules="required"
              v-slot="{ errors }"
            >
              <InputField
                label="데이터 제목"
                v-model="params.title"
                :errors="errors"
              />
            </ValidationProvider> -->

            <ValidationProvider
                rules="required"
                ref="provider1"
                v-slot="{ validate, errors }"
            >
              <InputFieldFile
                  label="인바디 데이터 업로드"
                  btnText="파일 업로드"
                  accept=".xlsx, .xls, .csv, .png, .svg, .jpg, .jpeg"
                  :value="inBodyDataParams.file ? inBodyDataParams.file.name : ''"
                  :errors="errors"
                  :change="handleFileChange"
              />
            </ValidationProvider>

            <div style="height: 50px"></div>
            <div class="flex flexAlignC">
              <MainButton btnText="등록" type="submit" width="auto"/>
            </div>
          </form>
        </ValidationObserver>
      </BasicModal>

      <BasicAlertModal
          :isShowModal="showAlertDelete"
          @close-modal="handleCLose"
          btnSubmitText="확인"
          size="md"
          :handleSubmit="handleDelete"
      >
        <h3>해당 연구를 삭제합니다.</h3>

        계속진행하시겠습니까?
      </BasicAlertModal>

      <BasicAlertModal
          :isShowModal="showequipmentDataDelete"
          @close-modal="handleCLose"
          btnSubmitText="확인"
          size="md"
          :handleSubmit="handleEquipmentDataDelete"
      >
        <h3>해당 데이터를 삭제합니다.</h3>

        계속진행하시겠습니까?
      </BasicAlertModal>

      <!--인바디 데이터 등록 모달 -->
      <BasicAlertModal

          :isShowModal="showAlertInBodyRegist"
          @close-modal="handleCLose"
          size="md"
      >
        <h3 v-if="dataType === 'inbody'">입력한 인바디 연구를 등록합니다.</h3>
        <h3 v-else>입력한 데이터를 등록합니다.</h3>

        계속진행하시겠습니까?
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="" @submit.prevent="handleSubmit(() => handleInsertInBodyInfo())">

            <div style="height: 50px"></div>
            <div class="flex flexAlignC">
              <MainButton btnText="확인" type="submit" width="auto"/>
            </div>
          </form>
        </ValidationObserver>
      </BasicAlertModal
      >
      <BasicAlertModal
          :isShowModal="showAlertDataRegist"
          @close-modal="handleCLose"
          size="md"
      >
        <h3 v-if="dataType === 'research'">입력한 안단테 핏 연구를 등록합니다.</h3>
        <h3 v-else>입력한 안단테 핏 데이터를 등록합니다.</h3>

        계속진행하시겠습니까?
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="" @submit.prevent="handleSubmit(() => handleUploadEquipmentData())">

            <div style="height: 50px"></div>
            <div class="flex flexAlignC">
              <MainButton btnText="확인" type="submit" width="auto"/>
            </div>
          </form>
        </ValidationObserver>
      </BasicAlertModal>


    </section>
  </div>
</template>
<script>
import axios from '@/axios/axios';
import {apiBaseURL, resolveApiUrl} from "@/data/url";
import * as jwtUtil from "@/utils/jwtUtil";
import {mapActions} from "vuex";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import InputField from "@/components/formControl/InputField.vue";
import BasicModal from "@/components/modal/BasicModal";
import BasicAlertModal from "@/components/modal/BasicAlertModal";
import InputFieldFiles from "@/components/formControl/InputFieldFiles.vue"; // 다건등록파일(QR) 컴포넌트
import InputFieldFile from "@/components/formControl/InputFieldFile.vue"; // 단건등록파일(InBody) 컴포넌트s
import MainButton from "@/components/button/MainButton.vue";
import AdminInBodyMultiselect from "@/components/inbody/admin/AdminInBodyMultiselect.vue";
import AdminInBodyTable from "@/components/inbody/admin/AdminInBodyTable.vue";
import {read, utils} from "xlsx";


export default {
  name: "EquipmentData",
  components: {
    AdminInBodyTable,
    AdminInBodyMultiselect,
    BasicModal,
    ValidationObserver,
    ValidationProvider,
    InputField,
    InputFieldFiles,
    InputFieldFile,
    BasicAlertModal,
    MainButton,
  },
  data() {
    return {
      inBodyTableKey: 0,
      selectedInBodyOptions: [],
      InBodyOptions: [],
      studyIdx: 1,
      targetIdx: 1,
      currentTab: 0,
      perPage: 15,
      currentPage: 1,
      totalCnt: 0,
      searchHistoryCnt: 0,
      sortBy: 'IDX',
      sortDesc: false,
      searchText: "",
      InBodyFields: [
        {
          key: 'NO',
          label: 'NO',
          class: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'DATE&TIMES',
          label: 'DATE&TIMES',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ID',
          label: 'ID',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'AGE',
          label: 'AGE',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'HEIGHT',
          label: 'HEIGHT',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'GENDER',
          label: 'GENDER',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'WEIGHT',
          label: 'WEIGHT',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'WEIGHT_MIN',
          label: 'WEIGHT_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'WEIGHT_MAX',
          label: 'WEIGHT_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ICW(Intracellular Water)',
          label: 'ICW(Intracellular Water)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ICW_MIN',
          label: 'ICW_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ICW_MAX',
          label: 'ICW_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW(Extracellular Water)',
          label: 'ECW(Extracellular Water)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW_MIN',
          label: 'ECW_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW_MAX',
          label: 'ECW_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'TBW(Total Body Water)',
          label: 'TBW(Total Body Water)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'TBW_MIN',
          label: 'TBW_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'TBW_MAX',
          label: 'TBW_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Protein',
          label: 'Protein',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Protein_MIN',
          label: 'Protein_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Protein_MAX',
          label: 'Protein_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Mineral',
          label: 'Mineral',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Mineral_MIN',
          label: 'Mineral_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Mineral_MAX',
          label: 'Mineral_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'FAT',
          label: 'FAT',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'FAT_MIN',
          label: 'FAT_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'FAT_MAX',
          label: 'FAT_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'SLM(Soft Lean Mass)',
          label: 'SLM(Soft Lean Mass)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'SLM_MIN',
          label: 'SLM_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'SLM_MAX',
          label: 'SLM_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'FFM(Fat Free Mass)',
          label: 'FFM(Fat Free Mass)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'FFM_MIN',
          label: 'FFM_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'FFM_MAX',
          label: 'FFM_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'SMM(Skeletal Muscle Mass)',
          label: 'SMM(Skeletal Muscle Mass)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'SMM_MIN',
          label: 'SMM_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'SMM_MAX',
          label: 'SMM_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'PBF(Percent Body Fat)',
          label: 'PBF(Percent Body Fat)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'PBF_MIN',
          label: 'PBF_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'PBF_MAX',
          label: 'PBF_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BMI',
          label: 'BMI',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BMI_MIN',
          label: 'BMI_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BMI_MAX',
          label: 'BMI_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'WHR',
          label: 'WHR',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'WHR_MIN',
          label: 'WHR_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'WHR_MAX',
          label: 'WHR_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(RA)',
          label: 'Segmental Water(RA)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(RA)_MIN',
          label: 'Segmental Water(RA)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(RA)_MAX',
          label: 'Segmental Water(RA)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(LA)',
          label: 'Segmental Water(LA)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(LA)_MIN',
          label: 'Segmental Water(LA)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(LA)_MAX',
          label: 'Segmental Water(LA)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(TR)',
          label: 'Segmental Water(TR)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(TR)_MIN',
          label: 'Segmental Water(TR)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(TR)_MAX',
          label: 'Segmental Water(TR)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(RL)',
          label: 'Segmental Water(RL)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(RL)_MIN',
          label: 'Segmental Water(RL)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(RL)_MAX',
          label: 'Segmental Water(RL)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(LL)',
          label: 'Segmental Water(LL)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(LL)_MIN',
          label: 'Segmental Water(LL)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Water(LL)_MAX',
          label: 'Segmental Water(LL)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW/TBW(Total)',
          label: 'ECW/TBW(Total)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW/TBW(RA)',
          label: 'ECW/TBW(RA)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW/TBW(LA)',
          label: 'ECW/TBW(LA)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW/TBW(TR)',
          label: 'ECW/TBW(TR)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW/TBW(RL)',
          label: 'ECW/TBW(RL)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'ECW/TBW(LL)',
          label: 'ECW/TBW(LL)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(RA)',
          label: 'Segmental Lean(RA)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(RA)_MIN',
          label: 'Segmental Lean(RA)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(RA)_MAX',
          label: 'Segmental Lean(RA)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(LA)',
          label: 'Segmental Lean(LA)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(LA)_MIN',
          label: 'Segmental Lean(LA)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(LA)_MAX',
          label: 'Segmental Lean(LA)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(TR)',
          label: 'Segmental Lean(TR)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(TR)_MIN',
          label: 'Segmental Lean(TR)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(TR)_MAX',
          label: 'Segmental Lean(TR)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(RL)',
          label: 'Segmental Lean(RL)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(RL)_MIN',
          label: 'Segmental Lean(RL)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(RL)_MAX',
          label: 'Segmental Lean(RL)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(LL)',
          label: 'Segmental Lean(LL)',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(LL)_MIN',
          label: 'Segmental Lean(LL)_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Segmental Lean(LL)_MAX',
          label: 'Segmental Lean(LL)_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BFM Control',
          label: 'BFM Control',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'FFM Control',
          label: 'FFM Control',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Body Cell Mass',
          label: 'Body Cell Mass',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BCM_MIN',
          label: 'BCM_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BCM_MAX',
          label: 'BCM_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Bone Mineral Content',
          label: 'Bone Mineral Content',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BMC_MIN',
          label: 'BMC_MIN',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BMC_MAX',
          label: 'BMC_MAX',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'AC',
          label: 'AC',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'AMC',
          label: 'AMC',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'VFA',
          label: 'VFA',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'BMR',
          label: 'BMR',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'TBW/FFM',
          label: 'TBW/FFM',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1khz-RA Impedance',
          label: '1khz-RA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1khz-LA Impedance',
          label: '1khz-LA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1khz-TR Impedance',
          label: '1khz-TR Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1khz-RL Impedance',
          label: '1khz-RL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1khz-LL Impedance',
          label: '1khz-LL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-RA Impedance',
          label: '5khz-RA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-LA Impedance',
          label: '5khz-LA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-TR Impedance',
          label: '5khz-TR Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-RL Impedance',
          label: '5khz-RL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-LL Impedance',
          label: '5khz-LL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-RA Impedance',
          label: '50khz-RA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-LA Impedance',
          label: '50khz-LA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-TR Impedance',
          label: '50khz-TR Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-RL Impedance',
          label: '50khz-RL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-LL Impedance',
          label: '50khz-LL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-RA Impedance',
          label: '250khz-RA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-LA Impedance',
          label: '250khz-LA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-TR Impedance',
          label: '250khz-TR Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-RL Impedance',
          label: '250khz-RL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-LL Impedance',
          label: '250khz-LL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '500khz-RA Impedance',
          label: '500khz-RA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '500khz-LA Impedance',
          label: '500khz-LA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '500khz-TR Impedance',
          label: '500khz-TR Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '500khz-RL Impedance',
          label: '500khz-RL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '500khz-LL Impedance',
          label: '500khz-LL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1Mhz-RA Impedance',
          label: '1Mhz-RA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1Mhz-LA Impedance',
          label: '1Mhz-LA Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1Mhz-TR Impedance',
          label: '1Mhz-TR Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1Mhz-RL Impedance',
          label: '1Mhz-RL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '1Mhz-LL Impedance',
          label: '1Mhz-LL Impedance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-RA Reactance',
          label: '5khz-RA Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-LA Reactance',
          label: '5khz-LA Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-TR Reactance',
          label: '5khz-TR Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-RL Reactance',
          label: '5khz-RL Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-LL Reactance',
          label: '5khz-LL Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-RA Reactance',
          label: '50khz-RA Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-LA Reactance',
          label: '50khz-LA Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-TR Reactance',
          label: '50khz-TR Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-RL Reactance',
          label: '50khz-RL Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-LL Reactance',
          label: '50khz-LL Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-RA Reactance',
          label: '250khz-RA Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-LA Reactance',
          label: '250khz-LA Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-TR Reactance',
          label: '250khz-TR Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-RL Reactance',
          label: '250khz-RL Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-LL Reactance',
          label: '250khz-LL Reactance',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-RA Phase Angle',
          label: '5khz-RA Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-LA Phase Angle',
          label: '5khz-LA Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-TR Phase Angle',
          label: '5khz-TR Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-RL Phase Angle',
          label: '5khz-RL Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '5khz-LL Phase Angle',
          label: '5khz-LL Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-RA Phase Angle',
          label: '50khz-RA Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-LA Phase Angle',
          label: '50khz-LA Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-TR Phase Angle',
          label: '50khz-TR Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-RL Phase Angle',
          label: '50khz-RL Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50khz-LL Phase Angle',
          label: '50khz-LL Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-RA Phase Angle',
          label: '250khz-RA Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-LA Phase Angle',
          label: '250khz-LA Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-TR Phase Angle',
          label: '250khz-TR Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-RL Phase Angle',
          label: '250khz-RL Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '250khz-LL Phase Angle',
          label: '250khz-LL Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: '50kHz-Whole Body Phase Angle',
          label: '50kHz-Whole Body Phase Angle',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Systolic',
          label: 'Systolic',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Diastolic',
          label: 'Diastolic',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Heart Rate',
          label: 'Heart Rate',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Electrode',
          label: 'Electrode',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Posture',
          label: 'Posture',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Access',
          label: 'Access',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Dialysis',
          label: 'Dialysis',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Paralysis',
          label: 'Paralysis',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'SMI',
          label: 'SMI',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'Target Weight',
          label: 'Target Weight',
          class: 'text-center',
          thClass: 'text-center'
        },
      ],

      fields: [
        {
          key: 'selected',
          label: '',
          class: 'text-center',
          thClass: 'text-center'
        },
        {
          // virtual column
          key: 'CNT',
          label: 'No',
          class: 'text-center'
        },
        {
          key: 'AndanteFit',
          label: '장비명칭',
          sortable: false,
          formatter(value) {
            switch (value) {
              default:
                return 'AndanteFittest'
            }
          }
        },
        {
          key: 'TEST_DATE',
          label: '테스트날짜',
          sortable: false
        },
        {
          key: 'ID',
          label: '아이디',
          sortable: false,
          /* variant: 'danger' */
        },
        {
          key: 'NAME',
          label: '이름',
          sortable: false
        },
        {
          key: 'GENDER',
          label: '성별',
          sortable: false,
          formatter(value) {
            switch (value) {
              case 'F':
                return '여'
              case 'M':
                return '남'
              default:
                return ''
            }
          }
        },
        {
          key: 'BIRTH',
          label: '생년월일',
          sortable: false
        },
        {
          key: 'SPPB_SCORE',
          label: 'SPPB총점 (12점만점)',
          sortable: false,
        },
        {
          key: 'BALANCE_SCORE',
          label: '정적균형점수 (4점만점)',
          sortable: false
        },
        {
          key: 'GAIT_SPEED_SCORE',
          label: '보행속도점수',
          sortable: false
        },
        {
          key: '5X_SIT_TO_STAND_SCORE',
          label: '일어서기점수',
          sortable: false
        },
        {
          key: 'SIDE_BY_SIDE_TIME',
          label: '정적균형검사 일반자세유지시간',
          sortable: false
        },
        {
          key: 'SEMI_TANDEM_TIME',
          label: '정적균형검사 반일렬자세유지시간',
          sortable: false
        },
        {
          key: 'TANDEM_TIME',
          label: '정적균형검사 일렬자세유지시간',
          sortable: false
        },
        {
          key: 'WALKING_DISTANCE',
          label: '보행속도검사 이동거리',
          sortable: false
        },
        {
          key: 'WALKING_TIME',
          label: '보행속도검사 이동시간',
          sortable: false
        },
        {
          key: 'GAIT_SPEED',
          label: '보행속도검사 이동속도',
          sortable: false
        },
        {
          key: '5X_SIT_TO_STAND_TIME',
          label: '일어서기검사 소요시간',
          sortable: false
        },
        {
          key: 'FUNCTIONAL_AGE',
          label: '신체나이',
          sortable: false
        },
        {
          key: 'FRAILTY_INDEX',
          label: '노쇠지수',
          sortable: false
        },
      ],
      activeRightTab: 2,
      apiBaseURL: apiBaseURL,
      user: this.$store.state.auth.user,
      headers: {
        Authorization:
            "Bearer " +
            localStorage.getItem(jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN),
        "My-Custom-Header": "foobar",
      },
      itemORG: [],
      items: [],
      itemsActive: {},
      html: null,
      params: {
        title: "",
        files: [],
        studyIdx: 0,
        dataType: ""
      },
      inBodyInfoParams: {
        idx: 0,
        title: "",
        regDate: null,
        regIdx: -1,
      },
      inBodyDataParams: {
        targetIdx: 0,
        file: null,
      },
      isShowModalSurvey: false,
      detailSurveyIdx: null, // 등록: null, 수정: survey idx
      detailIsSubmited: false,
      form: {
        test: "",
      },
      isShowModal: false,
      isShowModalEdit: false,
      inbodyDataRegist: false,
      showAlertEdit: false,
      showAlertDelete: false,
      showAlertDataRegist: false,
      tableItems: [],
      registResearchName: false,
      registInbodyRegistName: false,
      dataType: "",
      showequipmentDataDelete: false,
      showAlertInBodyRegist: false,
    };
  }, mounted() {
    this.getAllData();
    // this.InBodyFields = this.fields.map(field => ({id: field.key}));
  },
  watch: {
    'itemsActive.studyIdx': function (newStudyIdx, oldStudyIdx) {
      if (newStudyIdx !== oldStudyIdx) {
        this.getItems(newStudyIdx);
      } else {
        this.getItems(oldStudyIdx);
      }
    },
    'itemsActive.IDX': function (newIDX, oldIdx) {
      if (newIDX !== oldIdx) {
        this.getItems(newIDX);
      } else {
        this.getItems(oldIdx);
      }
    },
    activeRightTab(newTab) {
      console.log("탭이 바뀜:", newTab);

      if (newTab === 2) {
        this.getAll(); // equipment 데이터 api
      } else {
        this.getAllInBody(); // 인바디 데이터 api
        this.selectedInBodyOptions = [];

      }

      this.getAllData();
    },
  },
  methods: {
    handleNewLine(str) {
      return String(str).replace(/(?:\r\n|\r|\n)/g, "</br>");
    },
    getItems(studyIdx) {
      const that = this;
      if (this.activeRightTab == 1) {
        if(studyIdx === undefined) {
          return;
        }
        return that.getAllInBodyData(studyIdx)
            .then((res) => {
              this.tableItems = res;
              this.InBodyOptions = this.InBodyFields.map(h => h.key);
            })
            .catch((error) => {
              console.log(error);
            });
      } else {
        if(studyIdx === undefined) {
          return;
        }
        return this.equipmentDataList({
          studyIdx: this.itemsActive.studyIdx,
          currentPage: this.currentPage,
          perPage: this.perPage,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          searchText: this.searchText
        })
            .then(response => {
              const tableItems = response.items
              this.totalCnt = response.totalCnt;
              this.tableItems = response.items;
              return tableItems
            })
            .catch((error) => {
              console.log(error)
              // this.$alert("알림", "설문지 조회에 실패했습니다.");
              return []
            })
      }
    },
  onClickShowDetail(row) {
    this.detailSurveyIdx = row.item.IDX
    this.isShowModalSurvey = true
  },
  ...mapActions("equipmentData", [
    "equipmentDataList",
    "getAll",
    "uploadEquipmentData",
    "deleteEquipmentData",
    "loadXML",
    "deleteResearch",
    "getTitle",
    "getAllInBody",
    "insertInBodyInfo",
    "uploadInBodyData",
    "getAllInBodyData",
    "deleteInBody",

  ]),
  downloadEquipmentData() {
    const selectedItems = this.tableItems.filter(item => item.selected);
    const selectedIDXArray = selectedItems.map(item => item.IDX);
    var params = {
      studyIdx: this.itemsActive.studyIdx,
      idxArray: selectedIDXArray
    };
    axios.post('/api/equipmentData/excel', params, {responseType: 'arraybuffer'})
        .then(response => {
          let date = new Date();
          let yyyy = date.getFullYear();
          let mm = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
          let dd = String(date.getDate()).padStart(2, '0');
          let fileName = `andante-fit-data-${yyyy}-${mm}-${dd}.xlsx`;

          const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers["content-type"]}));
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.log("error: " + error)
          return []
        });
  },

    downloadInBodyData() {
      const selectedHeader = this.selectedInBodyOptions.map(item => item.id);
      // const selectedIDXArray = selectedItems.map(item => item.IDX);
      var params = {
        targetIdx: this.itemsActive.IDX,
        selectedKeys: selectedHeader
      };
      console.log(params);
      axios.post('/api/inBody/excel', params, {responseType: 'arraybuffer'})
                    .then(response => {
                      let date = new Date();
                      let yyyy = date.getFullYear();
            let mm = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
            let dd = String(date.getDate()).padStart(2, '0');
            let fileName = `inbody-data-${yyyy}-${mm}-${dd}.xlsx`;

            const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers["content-type"]}));
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(error => {
            console.log("error: " + error)
            return []
          });
    },
  onSubmit() {
  },
  onClickSearch() {
    var that = this;
    console.log(that.itemORG);
    const new_obj = that.lodash.filter(that.itemORG, function (o) {
      return o.title.includes(that.searchText);
    });
    that.items = new_obj;

    // 첫 번째 아이템의 studyIdx 값을 가져오기
    const firstItem = new_obj[0];
    const studyIdx = firstItem ? firstItem.studyIdx : 0;

    this.itemsActive = firstItem;
    this.studyIdx = studyIdx;
    this.getItems(studyIdx);
  },
  handleCLose() {
    this.isShowModal = false;
    this.isShowModalEdit = false;
    this.showAlertEdit = false;
    this.showAlertDelete = false;
    this.showAlertDataRegist = false;
    this.registResearchName = false;
    this.showequipmentDataDelete = false;
    this.showAlertInBodyRegist = false;
    this.registInbodyRegistName= false;
    this.inbodyDataRegist = false;
    this.inBodyInfoParams = {
      idx: 0,
      title: "",
      regDate: null,
      regIdx: -1,
    },
    this.dataType = "";
    this.params = {
      title: "",
      files: [],
      studyIdx: 0,
      dataType: "",
    };
    this.searchText = ""
    if (this.$refs.dataTable) {
      this.$refs.dataTable.refresh();
    }
    if (this.itemsActive) {
      if (this.itemsActive.studyIdx) {
        console.log("??")
        this.getItems(this.itemsActive.studyIdx);
      }
    }
    if(AdminInBodyTable) {
      this.getAllData();
    }
  },
  showAlert() {
    this.$bvModal.show("alertModal");
  },
  getAllData() {
    const that = this;
    if (this.activeRightTab == 2) {
      this.getAll()
          .then((res) => {
            that.items = res;
            that.itemORG = res;
            if (that.lodash.isEmpty(res[0])) {
              this.itemsActive = null;
            } else {
              that.itemsActive = res[0];
              that.loadData();
            }
          })
          .catch((error) => {
            console.log(error);
          });
    } else {
      that.getAllInBody()
          .then((res) => {
            this.items = res.items;
            this.itemORG = res.items;
            if (that.lodash.isEmpty(res.items[0])) {
              this.itemsActive = null;
            } else {
              this.itemsActive = res.items[0];
              this.loadData();
              this.targetIdx = this.itemsActive.IDX;
              this.getItems(this.targetIdx);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }

  },
  handleSelectItem(item) {
    this.itemsActive = item;
    this.studyIdx = item.studyIdx;
    this.loadData();
  },
  handleSubmitClick() {
    if (this.dataType) { //연구 등록
      if (this.params.title) {
        this.showAlertDataRegist = true;
      }
    } else { //QR코드 업로드
      if (this.itemsActive) {
        if (this.params.files) {
          this.showAlertDataRegist = true;
        } else {
          this.$alert("알림", "파일이 없습니다.");
        }
      } else {
        this.handleCLose();
        this.$alert("알림", "연구를 선택해주세요.");
      }
    }
  },
  handleUploadEquipmentData() {
    const that = this;
    if (this.dataType) { //연구 등록
      this.params.dataType = this.dataType;
      this.uploadEquipmentData(this.params)
          .then(() => {
            that.handleCLose();
            that.getAllData();
          })
          .catch(() => {
            const that = this;
            that.handleCLose();
            that.getAllData();
            that.$alert("알림", "연구 등록 실패");
          });
    } else { //QR코드 업로드
      if (this.itemsActive) {
        if (this.itemsActive.studyIdx) {
          this.params.studyIdx = this.itemsActive.studyIdx;
          this.uploadEquipmentData(this.params)
              .then(() => {
                that.handleCLose();
              })
              .catch(() => {
                const that = this;
                that.handleCLose();
                that.$alert("알림", "파일 업로드 실패");
              });
        } else {
          that.handleCLose();
          that.$alert("알림", "연구를 선택해주세요.");
        }
      } else {
        that.handleCLose();
        that.$alert("알림", "연구를 선택해주세요.");
      }
    }
  },
  //다건 파일등록
  async handleFilesChange(e) {
    // 유효성 검사
    const {valid} = await this.$refs.provider1.validate(e);
    if (!valid) return;

    // 새로 선택된 파일 목록을 배열로 변환
    const newFiles = Array.from(e.target.files);

    // 기존 파일 배열이 없다면 초기화
    if (!this.params.files) {
      this.params.files = [];
    }

    // 이름과 크기 기준으로 중복 제거 후 추가
    const uniqueFiles = [
      ...this.params.files,
      ...newFiles
    ].filter((file, index, self) =>
        index === self.findIndex(f => f.name === file.name && f.size === file.size)
    );

    this.params.files = uniqueFiles;
  },
  //단건 파일등록
  async handleFileChange(e) {
    // 유효성 검사
    const {valid} = await this.$refs.provider1.validate(e);

    if (valid) {
      this.inBodyDataParams.file = e.target.files[0];
    } else {
      return;
    }
  },

  removeFile(index) {
    this.params.files = this.params.files.filter((_, i) => i !== index);
  },

  handleDelete() {
    const that = this;
    if(this.activeRightTab == 1) {
      if (this.itemsActive) {
        that.inBodyInfoParams.idx = this.itemsActive.IDX;
        that.deleteInBody(that.inBodyInfoParams)
            .then(() => {
              that.getAllData();
              that.handleCLose();
            })
            .catch((error) => {
              alert(error);
            });
      } else {
        this.handleCLose();
        this.$alert("알림", "삭제할 연구가 없습니다.");
      }

    } else {
      if (this.itemsActive) {
        that
            .deleteResearch(this.itemsActive.studyIdx)
            .then(() => {
              that.getAllData();
              that.handleCLose();
            })
            .catch((error) => {
              alert(error);
            });
      } else {
        this.handleCLose();
        this.$alert("알림", "삭제할 연구가 없습니다.");
      }
    }

  },
  handleEquipmentDataDelete() {
    const that = this;
    if (this.totalCnt) {
      const selectedItems = this.tableItems.filter(item => item.selected);

      if (selectedItems.length > 0) {
        const selectedIDXArray = selectedItems.map(item => item.IDX);
        that.deleteEquipmentData(selectedIDXArray)
            .then(() => {
              that.handleCLose();
            })
            .catch((error) => {
              alert(error.response.data);
            });
      } else {
        that.handleCLose();
        that.$alert("알림", "삭제할 데이터를 선택해주세요.");
      }
    } else {
      that.handleCLose();
      that.$alert("알림", "삭제할 데이터가 없습니다.");
    }
  },
  async loadData() {
    const that = this;
    if (!that.lodash.isEmpty(that.itemsActive)) {
      const f = await fetch(resolveApiUrl(that.itemsActive.filePath), {
        headers: that.headers,
      });
      const ab = await f.arrayBuffer();
      // /* parse workbook */
      const wb = read(ab);
      this.html = utils.sheet_to_html(wb.Sheets[wb.SheetNames[0]]);
    }
  },


  onClickSearchForInBody() {
    const that = this;
    const new_obj = that.lodash.filter(that.itemORG, function (o) {
      return o.TITLE.includes(that.searchText);
    });
    that.items = new_obj;

    // 첫 번째 아이템의 IDX 값을 가져오기
    const firstItem = new_obj[0];
    const IDX = firstItem ? firstItem.IDX : 0;

    this.itemsActive = firstItem;
    this.targetIdx = IDX;

    this.getItems(this.targetIdx);
  },


  handleInBodySubmitClick() {
    if (this.inBodyInfoParams.title) {
      this.showAlertInBodyRegist = true;
    } else { // 인바디 엑셀 업로드
      const that = this;
      if (this.itemsActive) {
        if (this.inBodyDataParams.file) {
          this.showAlertInBodyRegist = true;
        } else {
          that.handleCLose();
          that.$alert("알림", "파일이 없습니다.");
        }
      } else {
        that.handleCLose();
        that.$alert("알림", "연구를 선택해주세요.");
      }
    }
  },


  handleInsertInBodyInfo() {
      const that = this;
    if (this.dataType == 'inbody') { // 인바디 연구 등록
      that.insertInBodyInfo(this.inBodyInfoParams)
          .then(() => {
            this.handleCLose();
            //this.getAllData(); //인바디로 변경
          })
          .catch(() => {
            const that = this;
            that.handleCLose();
            // that.getAllData();
            that.$alert("알림", "인바디 연구 등록 실패");
          });
    } else {
      const that = this;
      if (this.itemsActive) {
        if (this.itemsActive.IDX) {
          this.inBodyDataParams.targetIdx = this.itemsActive.IDX;
          that.uploadInBodyData(this.inBodyDataParams)
              .then(() => {
                that.handleCLose();
              })
              .catch(() => {
                const that = this;
                that.handleCLose();
                that.$alert("알림", "파일 업로드 실패");
              });
        }
      } else {
        that.$alert("알림", "연구를 선택해주세요.");
      }
    }
  },
}
}
</script>

<style scoped lang="scss">
.tableResult ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}

.bootstrapTableContainer ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}

.btn-delete {
  display: inline-block;
  color: #252525;
  font-size: 1.2rem;
  line-height: 2rem;
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  font-weight: 500;
  text-align: center;
  border: 1px solid transparent;
  cursor: pointer;

  &.bordered {
    border-radius: 2.5rem;
  }
}

</style>